import { FlexBox } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { memo } from 'react';

import { ConversationCopilotDropdown } from 'components/conversation';

import { ConversationActivityLogButton } from './components/activityLogButton/conversationActivityLogButton';
import { ConversationHeaderCsatMenu } from './components/csatMenu/csatMenu';
import { ConversationFocusModeButton } from './components/focusModeButton/focusModeButton';
import { ConversationHeaderSidebarOpenButton } from './components/sidebarOpenButton/conversationHeaderSidebarOpenButton';
import { ConversationTransferToAgent } from './components/transferToAgent/conversationTransferToAgent';
import { ConversationTransferToNumberButton } from './components/transferToNumberButton/conversationTransferToNumberButton';
import { ConversationTransferToQueue } from './components/transferToQueue/conversationTransferToQueue';
import styles from './conversationToolbar.module.scss';

type ConversationToolbarImplProps = {
  isFocusMode?: boolean;
};

const ConversationToolbarImpl = ({
  isFocusMode = false,
}: ConversationToolbarImplProps): JSX.Element => {
  const isNormalMode = !isFocusMode;
  const hasLogAccess = useHasAccess('conversation.log');

  return (
    <div className={styles.root}>
      {isNormalMode && (
        <FlexBox minWidth="0px">
          <FlexBox minWidth="100px">
            <ConversationTransferToAgent />
          </FlexBox>
          <FlexBox minWidth="100px">
            <ConversationTransferToQueue />
          </FlexBox>
        </FlexBox>
      )}
      <FlexBox gap="200">
        {isNormalMode && (
          <>
            <ConversationTransferToNumberButton />
            <ConversationHeaderCsatMenu />
            {hasLogAccess && <ConversationActivityLogButton />}
            <ConversationHeaderSidebarOpenButton />
          </>
        )}
        {isFocusMode && (
          <>
            <ConversationCopilotDropdown
              buttonProps={{ variant: 'tertiary' }}
            />
            {hasLogAccess && <ConversationActivityLogButton />}
          </>
        )}
        <ConversationFocusModeButton />
      </FlexBox>
    </div>
  );
};

export const ConversationToolbar = memo(ConversationToolbarImpl);
